

















































































import { defineComponent, type PropType } from "vue-demi";
import type {
  PageData,
  PageDataPropUnion,
} from "@constructor/shared-entity/type";
import MPGroup from "../MPGroup/MPGroup.vue";
import MPRowSlider from "../MPRowSlider/MPRowSlider.vue";
import MPRatingBlock from "../MPRatingBlock/MPRatingBlock.vue";

export default defineComponent({
  name: "MPShopsSlider",
  components: {
    MPRowSlider,
    MPGroup,
    MPRatingBlock,
  },
  props: {
    prop: {
      type: Array as PropType<PageDataPropUnion[]>,
      default: () => [],
    },
    data: {
      type: Object as PropType<PageData>,
      required: true,
    },
  },
  methods: {
    getCategoryList(list: { [key: string]: string }[] = []) {
      return list.map((c) => c.name).join(" · ");
    },
  },
});
